export const navigation = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Services", href: "/services" },
  { name: "Portfolio", href: "/portfolio" },
  { name: "Staff Augmentation", href: "/staff-augmentation" },
] as const;

export const navigationLetsTalk = [
  { name: "Let's Talk", href: "https://wa.me/+919925599253?text=Let%27s%20Talk%2C%20I%20have%20a%20query." }
] as const;